import AuthLayout from "../molecule/AuthLayout";
import LoginForm from "../molecule/LoginForm";

function LoginPage() {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}

export default LoginPage;
